<template>
  <div>
  <grid-row v-for="(index) in getNumOfRows" :key="index" column-align="center" col-spaced class="max-width">
    <grid-col col-size="1" v-for="colIndex in getNumOfColumns" :key="colIndex" v-if="isValidIndex(index, colIndex)">
      <meal-card-color v-if="color" :foods="meals[columnNumber * index + colIndex].items" :color="meals[columnNumber * index + colIndex].color" class="margin-top-m margin-left-m margin-right-m"></meal-card-color>
      <meal-card v-else :foods="meals[columnNumber * index + colIndex].items" :color="meals[columnNumber * index + colIndex].color" class="margin-top-m margin-left-m margin-right-m"></meal-card>
    </grid-col>
  </grid-row>
  </div>
</template>

<script>
import MealCard from 'BRAND/components/nutritionPlan/MealCard';
import MealCardColor from 'BRAND/components/nutritionPlan/MealCardColor';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';

export default {
  name: 'MealCardsGroup',
  components: {
    MealCard,
    GridRow,
    GridCol,
    MealCardColor
  },
  props: {
    meals: {
      type: Array,
      default: () => []
    },
    color: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      columnNumber: 5
    };
  },
  computed: {
    getNumOfRows () {
      const num = Math.ceil(this.meals.length / this.columnNumber);
      return [...Array(num).keys()];
    },
    getNumOfColumns () {
      return [...Array(this.columnNumber).keys()];
    }
  },
  methods: {
    isValidIndex (index, colIndex) {
      const isValid = (this.columnNumber * index + colIndex) < this.meals.length;
      return isValid;
    }
  }
};
</script>

<style scoped>

.max-width {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/MealCardsGroup.vue